<template>
  <!-- v-hover -->
  <el-table
    ref="dtTable"
    class="dt-table"
    :data="data"
    :max-height="height || data.length * 58 + 44 + 2"
    :highlight-current-row="highlightCurrentRow"
    stripe
    v-hover
    @current-change="handleCurrentChange"
    @selection-change="handleSelectionChange"
  >
    <!-- 复选插槽 -->
    <slot name="checkBox"></slot>
    <!-- 序号插槽 -->
    <slot name="index"></slot>
    <el-table-column
      v-for="item in newOptions"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      :min-width="item.width"
      :fixed="item.fixed || false"
      align="center"
    >
      <template slot-scope="scope">
        <!-- 当数据有绑定事件时 -->
        <template v-if="item.event">
          <template v-if="item.event === 'getImage'">
            <div class="tableImgWrap">
              <img class="tableImg" v-if="scope.row[item.prop]" :src="scope.row[item.prop]" alt="" />
              <span class="tableImgLine" v-else>--</span>
            </div>
          </template>
          <template v-else>
            <span class="cursor" @click="handleClick(item.event, scope.row)" :style="{ color: themeObj.color }">
              {{ scope.row[item.prop] }}{{ item.unit ? item.unit : '' }}
            </span>
          </template>
        </template>
        <!--需要传入html -->
        <template v-else-if="item.showPolicyCode">
          <template v-if="item.dic">
           
            {{ scope.row[item.prop] | getDicItemName(item.dic) }}{{ item.unit ? item.unit : '' }}
          </template>
          <template v-else>
           
            {{ getCeil(item.filterType, scope.row[item.prop]) }}{{ item.unit ? item.unit : '' }}
          </template>
          <span
            :style="{ display: 'block', padding: '2px', color: 'rgb(226, 124, 0)' }"
            v-if="scope.row.isExpireSoon == 1"
          >
            即将过期</span
          >
        </template>
        <!-- 当数据可编辑时 -->
        <template v-else-if="item.editType">
          <template v-if="item.editType === 'input'">
            <template v-if="scope.row.canEdit">
              <el-input v-model="scope.row[item.prop]" placeholder="请输入"></el-input>
            </template>
            <template v-else>{{ scope.row[item.prop] }} </template>
          </template>
          <template v-if="item.editType === 'select'">
            <template v-if="scope.row.canEdit">
              <el-select
                v-model="scope.row[item.prop]"
                clearable
                :disabled="item.disabled"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="inner in item.list || dicMap[item.dic]"
                  :label="inner.dicItemName"
                  :value="inner.dicItemCode"
                  :key="inner.dicItemCode"
                ></el-option>
              </el-select>
            </template>
            <template v-else>{{ scope.row[item.prop] }}</template>
          </template>
          <template v-if="item.editType === 'date'">
            <template v-if="scope.row.canEdit">
              <el-date-picker
                v-model="scope.row[item.prop]"
                value-format="yyyy-MM-dd hh:mm:ss"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-else>{{ moment(scope.row[item.prop]).format('YYYY-MM-DD') }}</template>
          </template>
        </template>
        <!-- 只是普通数据，需要查询字典转换或特定方法过滤 -->
        <template v-else>
          <template v-if="item.dic">
            {{ scope.row[item.prop] | getDicItemName(item.dic) }}{{ item.unit ? item.unit : '' }}
          </template>
          <template v-else-if="item.format">
            {{ scope.row[item.prop] | momentTime }}
          </template>
          <!--某个字段要打标记 -->
          <template v-else-if="item.isAddflag&&scope.row.policyType=='02'"> 
               <span class="WelfareFlag" v-if="item.WelfareFlag&&scope.row.isWelfare==1">弹性福利</span>
            <span class="redflag">*</span>{{scope.row[item.prop]}} </template>
          <template v-else>
             <span class="WelfareFlag" v-if="item.WelfareFlag&&scope.row.isWelfare==1">弹性福利</span>
            {{ getCeil(item.filterType, scope.row[item.prop]) }}{{ item.unit ? item.unit : '' }}
          </template>
        </template>
      </template>
    </el-table-column>
    <!-- 操作按钮插槽 -->
    <slot name="operate"></slot>
  </el-table>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    height: { type: [Number, String] },
    highlightCurrentRow: { type: Boolean, default: false },
    multipleData: { type: Array, default: () => [] },
  },
  computed: {
    newOptions() {
      return this.options.map((item) => {
        if (!item.width) {
          if (item.prop === 'name' || item.prop === 'title') {
            item.width = 'auto';
          } else if (/time$/i.test(item.prop) || /day$/i.test(item.prop)) {
            item.width = 160;
          } else {
            item.width = (item.label.length + 2) * 20;
          }
        }
        return item;
      });
    },
    getCeil() {
      return function (type, prop) {
        if (type) {
          return this.filterType(type, prop);
        } else {
          // 为了正常显示数字0
          if (!prop && prop !== 0) return '';
          return prop;
        }
      };
    },
    themeObj() {
      return this.$store.getters['layoutStore/getThemeObj'];
    },
    dicMap() {
      return this.$store.getters['getDicMap'];
    },
  },
  methods: {
    // 自定义过滤内容方法
    filterType(type, value) {
      return this[type](value);
    },
    // 保留两位小数并添加%
    fixedTwo(value) {
      return Number(value).toFixed(2);
    },
    // 自定义事件，子组件触发，父组件执行
    handleClick(event, row) {
      this.$emit(event, row);
    },
    // 单选框的回调
    handleCurrentChange(val) {
      this.$emit('current-change', val);
    },
    // 复选框的回调
    handleSelectionChange(val) {
      this.$emit('update:multipleData', val);
    },
  },
};
</script>
<style lang="less" scoped>
.dt-table {
  min-height: 92px;
  margin-bottom: 30px;
  .el-table__row td {
    border: none;
  }
  tr {
    th {
      padding: 0px;
      font-size: 14px;
      font-weight: bold;
      color: #333;
      background-color: #f9f9f9;
      &.is-leaf {
        border: none;
      }
    }
    td {
      height: 60px;
      padding: 0px;
      font-size: 14px;
      color: #333;
    }
  }
  .el-table-column--selection {
    .cell {
      padding-right: 14px;
      text-align: right;
    }
  }
  .tableImgWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    .tableImg {
      max-width: 100%;
      max-height: 100%;
    }
    .tableImgLine {
      display: block;
      line-height: 80px;
    }
  }
  .cursor {
    cursor: pointer;
  }
  .el-input__inner {
    text-align: center;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
.redflag{
  color: red;
  font-size: 16px;
}
.el-table .cell .WelfareFlag {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 66px;
  height: 18px;
  line-height: 18px;
  border-radius: 0px 0px 14px 0px;
  font-size: 12px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #ffffff;
  background: linear-gradient(270deg, #E27C00 0%, #F3B300 100%);
}
</style>
